import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';

import Picture from '../assets/pictures/moi-black-white.webp';
import Drums from '../assets/pictures/drums.webp';
import Guitar from '../assets/pictures/guitar.webp';
import Piano from '../assets/pictures/piano.webp';
import Clarinet from '../assets/pictures/clarinet.webp';

import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import '../utils/general.css';
import '../utils/home.css';

import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';

import { useLanguage } from '../components/languageContext';
import SkillsCarousel from '../components/skillsCarousel';
import Seo from '../components/seo';

function Home() {
  const { language } = useLanguage();

  const translations = language === 'en' ? enTranslations : frTranslations;

  return (
    <Container className='ps-home vertical-center mt-4 mb-5' fluid>
      <Seo title={translations.seo.home.title} description={translations.seo.home.description} />
      <Row className='ps-row mb-5 mt-5'>
        <Col lg={6} className="text-center mt-5">
          <Image
            src={Picture}
            roundedCircle
            alt="profil picture"
            style={{
              maxWidth: "500px",
              width: "100%",
              height: "auto"
            }}
          />
        </Col>
        <Col  lg={6} className='text-center align-self-center'>
          <Row className='ps-profil-title mt-2'>
            <h1>Pierre Saumet</h1>
            <h2>{translations.home.titre}</h2>
          </Row>
          <Row className='ps-profil-description'>
            {translations.home.intro.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
            <p>
              {translations.home.intro2}
            </p>
            <Carousel>
              <Carousel.Item>
                <Image src={Drums} alt="drums picture by Michael Dobrinski" rounded loading="lazy" className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.drums}</small></p>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <Image src={Guitar} alt="guitar picture by Vincet Nicolas" rounded loading="lazy" className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.guitar}</small></p>
                </Carousel.Caption>
             </Carousel.Item>
             <Carousel.Item>
                <Image src={Piano} alt="piano picture by David Pisnoy" rounded loading="lazy" className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.piano}</small></p>
                </Carousel.Caption>
             </Carousel.Item>
             <Carousel.Item>
                <Image src={Clarinet} alt="clarinet picture by Adam Cai" rounded loading="lazy" className='ps-profil-carousel-picture'/>
                <Carousel.Caption>
                  <p style={{ color: 'white' }}><small>{translations.home.clarinet}</small></p>
                </Carousel.Caption>
             </Carousel.Item>
            </Carousel>
          </Row>
        </Col>
        <Col className='ps-profil-techno text-center align-self-center' style={{ marginTop: "5em" }}>
          <Row>
            <h2 className='title'>
              {translations.home.skills.title}
            </h2>
          </Row>
          <Row>
            <SkillsCarousel />
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Home;
